import { ICallChecklist } from './callchecklist.types'
import { http } from '@/shared/https'

export class CallChecklistService implements ICallChecklist {
    populateDropdowns(id: number): any {
        return http.get(`api/InitiativeCallChecklist/sections/${id}`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                return {};
            }
        }).catch(error => {
            return error.response;
        });
    }

    get(id: number): any {
        return http.get(`api/InitiativeCallChecklist/${id}`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                return [];
            }
        }).catch(error => {
            return error.response;
        });
    }

    update(id, data): any {
        return http.put(`api/InitiativeCallChecklist/${id}`, data).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                return {};
            }
        }).catch(error => {
            return error;
        });
    }

    delete(key: string): any {
        return http.delete(`api/InitiativeCallChecklist/${key}`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                return {};
            }
        }).catch(error => {
            return error;
        });
    }
}